import { actions } from "./Reducer";
/**
 * Actions that fire saga watchers
 */

// singular
export const createArtisanAction = (formData, noRedirect) => ({
  type: actions.CREATE_ARTISAN,
  payload: formData,
  noRedirect,

});

export const updateArtisanAction = (id, formData) => ({
  type: actions.UPDATE_ARTISAN,
  payload: {
    id,
    formData,
  },
});

export const deleteArtisanAction = (id) => ({
  type: actions.DELETE_ARTISAN,
  payload: id,
});

// Plural
export const getArtisansAction = (body) => ({
  type: actions.GET_ARTISANS,
  payload: body,
});

// singular 
export const getArtisanAction = (artisanId) => ({
  type : actions.GET_ARTISAN,
  payload : artisanId
})

//
export const addEditorReviewArtisan = (artisanId,formData) => ({
  type: actions.ADD_EDITOR_REVEIW,
  payload: {
    artisanId,
    formData
  }
})

export const addFollower = (artisanId, userId) => ({
  type: actions.ADD_FOLLOWER_ARTISAN,
  payload: {
    artisanId,
    userId
  }
})

export const removeFollower = (artisanId, userId) => ({
  type: actions.REMOVE_FOLLOWER_ARTISAN,
  payload: {
    artisanId,
    userId
  }
})

export const getFollowers = (artisanId) => ({
  type: actions.GET_FOLLOWERS,
  payload: artisanId
})


export const UpdateArtisanLimitAction = (body) => ({
  type: actions.UPDATE_ARTISAN_LIMIT,
  payload: body
})


/**
 * Actions that are fired by redux-saga watchers
 */

// singular
export const getArtisanSuccessAction = artisan => ({
  type : actions.GET_ARTISAN_SUCCESS,
  payload : artisan
})

export const createArtisanSuccessAction = (artisan) => ({
  type: actions.CREATE_ARTISAN_SUCCESS,
  payload: artisan,
});

export const updateArtisanSuccessAction = (artisan) => ({
  type: actions.UPDATE_ARTISAN_SUCCESS,
  payload: artisan,
});

export const deleteArtisanSuccessAction = (artisanId) => ({
  type: actions.DELETE_ARTISAN_SUCCESS,
  payload: artisanId,
});

//
export const addFollowerSuccess = (payload) => ({
  type: actions.ADD_FOLLOWER_ARTISAN_SUCCESS,
  payload
})

export const removeFollowerSuccess = (payload) => ({
  type: actions.REMOVE_FOLLOWER_ARTISAN_SUCCESS,
  payload
})

export const getFollowersSuccess = (payload) =>({
  type: actions.GET_FOLLOWERS_SUCCESS,
  payload
})


// Plural
export const getArtisansSuccessAction = (artisans) => ({
  type: actions.GET_ARTISANS_SUCCESS,
  payload: artisans,
});


/**
 * Misc
 */
export const setArtisansIsLoadingAction = (isLoading) => ({
  type: actions.SET_ARTISANS_IS_LOADING,
  payload: isLoading,
});

export const setArtisansCountAction = (count) => ({
  type: actions.SET_ARTISANS_COUNT,
  payload: count,
});

export const setSearchValueAction = (value) => ({
  type: actions.SET_ARTISANS_SEARCH_VALUE,
  payload: value,
});
